/**
 * textSupportData
 *
 * Shared content for the Send a Text support page.
 */
export const textSupport = {
  title: "Send a Text",
  subtitle: "Get help sending text messages to your voters. Talk to our team or book a time for live guidance.",
  phoneLabel: "Live Support",
  phoneNumberDisplay: "(757) 821-2121",
  phoneNumberHref: "+17578212121",
  partnerTitle: "Visit RoboCent to Learn More",
  partnerDescription: "Advocacy Lab is owned by RoboCent / GOTV.com — powering campaigns at every level",
  partnerUrl: "https://robocent.com",
  scheduleTitle: "Prefer to schedule?",
  scheduleCta: "Book a Call",
};

// Reuse the same Calendly link used elsewhere
export { calendlySchedulingUrl } from "./doneForYouData";

// Dedicated Calendly link for Send Text quick consults
import { robocentQuickfireUrl } from '../scheduling/schedulingLinks';
export const sendTextCalendlyUrl = robocentQuickfireUrl;

// GOTV.com site link for additional context
export const gotvSiteUrl = "https://gotv.com";

export default { textSupport };

// Minimal pricing snapshot (inspired by Robocent public pricing)
export const textPricing = {
  note: "SMS pricing is based on 160‑char segments (70 with emojis/special chars). Full 10DLC compliance required.",
  tiers: [
    { label: "Text Message (SMS)", payg: "3¢/text", kickoff: "2.35¢/text", grassroots: "1.85¢/text" },
    { label: "Picture Message (MMS)", payg: "7¢/text", kickoff: "4.25¢/text", grassroots: "3.75¢/text" },
    { label: "Video Message (MMS)", payg: "9¢/text", kickoff: "5¢/text", grassroots: "4.5¢/text" },
  ],
  footnote: "Managed sending available. Two‑way conversation is free with every order.",
};


